// Copyright (c) 2022 by Move Closer

import { IVueI18n } from 'vue-i18n'

import { monthNamesRegistry } from '../contracts/months'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const mapMonthName = (month: number | string, locale: IVueI18n) => {
  return locale.t(`front.orders.OrdersListItem.months.${monthNamesRegistry[String(month)]}`)
}
